const IMAGE_EXTENSIONS = /\.(jpeg|jpg|png|gif|bmp|webp|svg|heic|avif)$/i;
const VIDEO_EXTENSIONS = /\.(mp4|webm|mov|avi|wmv|m4v)$/i;
const DOCUMENT_EXTENSIONS = /\.(pdf|doc|docx|xls|xlsx|ppt|pptx|txt)$/i;

export const getUrlFilePath = (url) => {
  const raw = String(url || "").trim();
  if (!raw) return "";

  const withoutQuery = raw.split("?")[0].split("#")[0];

  try {
    return decodeURIComponent(
      new URL(withoutQuery, "https://placeholder.local").pathname,
    );
  } catch {
    return withoutQuery;
  }
};

export const getFileKindFromUrl = (url, fileTypeHint) => {
  const hint = String(fileTypeHint || "")
    .trim()
    .toLowerCase();

  if (hint.startsWith("image")) return "image";
  if (hint.startsWith("video")) return "video";
  if (hint.includes("pdf") || hint.includes("application/")) return "document";

  const raw = String(url || "").trim();
  if (!raw) return "unknown";

  if (raw.startsWith("data:image/")) return "image";
  if (raw.startsWith("data:video/")) return "video";

  const path = getUrlFilePath(raw);

  if (IMAGE_EXTENSIONS.test(path)) return "image";
  if (VIDEO_EXTENSIONS.test(path)) return "video";
  if (DOCUMENT_EXTENSIONS.test(path)) return "document";

  return "file";
};

export const isImageFileUrl = (url, fileTypeHint) =>
  getFileKindFromUrl(url, fileTypeHint) === "image";

export const normalizeFileUrls = (value) => {
  if (value == null || value === "") return [];

  if (Array.isArray(value)) {
    return value.flatMap((item) => normalizeFileUrls(item));
  }

  if (typeof value === "object") {
    return normalizeFileUrls(
      value.url || value.src || value.file || value.value || "",
    );
  }

  const text = String(value).trim();
  if (!text) return [];

  const parts = text.split(/,\s*(?=https?:\/\/|data:)/i);
  if (parts.length > 1) {
    return parts.flatMap((part) => normalizeFileUrls(part.trim()));
  }

  if (/^https?:\/\//i.test(text) || text.startsWith("data:")) {
    return [text];
  }

  return [];
};
